import React, { FC, useMemo } from 'react';

import { useAnimatedNumber } from '../../hooks/use-animated-number.hook';
import Input, { InputProps } from '../input/input';
import { formatAnimatedNumber } from './format-animated-number.util';

export type AnimatedCalculatedInputProps = {
  animationDuration?: number;
  integer?: boolean;
  value: number;
} & Omit<InputProps, 'onChange' | 'value'>;

export const AnimatedCalculatedInput: FC<AnimatedCalculatedInputProps> = ({
  animationDuration,
  integer,
  maxDecimalPlaces,
  value,
  ...inputProps
}) => {
  const animatedValue = useAnimatedNumber(value, { duration: animationDuration });
  const formattedValue = useMemo(
    () =>
      formatAnimatedNumber(animatedValue, {
        integer,
        maximumFractionDigits: maxDecimalPlaces,
      }),
    [animatedValue, integer, maxDecimalPlaces],
  );

  return <Input {...inputProps} disabled onChange={() => {}} value={formattedValue} />;
};
